import Collection from 'core/model/Collection';
import BGPAnnouncementModel from './BGPAnnouncementModel';

class BGPAnnouncementCollection extends Collection {
  get url() {
    return '/api/ui/mitigations/announcements';
  }

  get defaultSortState() {
    return {
      field: 'mitigationIds',
      direction: 'desc'
    };
  }

  get filterFieldWhitelist() {
    return new Set(['typeLabel', 'mitigationIds', 'deviceName', 'matchEntriesString', 'actionEntriesString']);
  }

  get model() {
    return BGPAnnouncementModel;
  }

  get uniqueMitigationIds() {
    const allMitigationIds = this.unfiltered.flatMap((model) => model.mitigationIds);
    return [...new Set(allMitigationIds)];
  }

  deserialize(data) {
    const { updateDetails: announcementsArray = [] } = data || {};

    return super.deserialize(announcementsArray);
  }
}

export default BGPAnnouncementCollection;
